
export default function vernissages600(): any[] {
    return [
        {
            floats:{
                text: {
                    "position": {
                        "top" : -20,
                        "left": 0,
                        "width": 550,
                        "height": 200,
                        "opacity": 1,
                        "rotate": 0
                    },
                },
                order: {
                    "position": {
                        "top" : 195,
                        "left": 0,
                        "width": 150,
                        "height": 150
                    },
                },
                cover: {
                    "position": {
                        "top" : 195,
                        "left": 170,
                        "width": 230,
                        "height": 625
                    },
                },
                coverTitle: {
                    "position": {
                        "top": 587,
                        "left": 5,
                        "width": 220,
                        "height": 33,
                        "opacity": 1,
                        "rotate": 0
                    },
                },
                coverTitle2: {
                    "position": {
                        "top": 550,
                        "left": 5,
                        "width": 220,
                        "height": 33,
                        "opacity": 1,
                        "rotate": 0
                    },
                },
                image0:{
                    "position": {
                        "top" : 280,
                        "left": 420, 
                        "width": 120,
                        "height": 230
                    },
                },
                image1:{
                    "position": {
                        "top" : 530,
                        "left": 370, 
                        "width": 170,
                        "height": 230 
                    },
                },
                image2:{
                    "position": {
                        "top" : 780,
                        "left": 420, 
                        "width": 120,
                        "height": 120
                    },
                },
                image3:{
                    "position": {
                        "top" : 360,
                        "left": -40, 
                        "width": 190,
                        "height": 230
                    },
                },
                image4:{
                    "position": {
                        "top" : 610,
                        "left": 0, 
                        "width": 150,
                        "height": 150 
                    },
                },
                image5:{
                    "position": {
                        "top" : 780,
                        "left": 0, 
                        "width": 150,
                        "height": 190 
                    },
                }, 
                imageStyle: {
                    "border": "5px solid var(--force-contast-color)",
                    "backgroundColor": "#508750",
                    "boxShadow": "0 13px 22px 0 #00000066, 0 2px 5px #000000EE"
                }, 
                "imageBorder": {
                    "borderWidth": 5,
                    "borderStyle": "dashed",
                    "borderColor": "var(--force-contast-color)"
                } ,
            },
            height: 990,
        },
        {
            floats:{
                text: {
                    "position": {
                        "top" : 605,
                        "left": 0, 
                        "width": 400,
                        "height": 230,
                        "opacity": 0,
                        "rotate": 0
                    }
                },
                order:{
                    "position": {
                        "top" : 0,
                        "left": 420, 
                        "width": 120,
                        "height": 120
                    }
                },
                cover: {
                    "position": {
                        "top" : 0,
                        "left": 0, 
                        "width": 230,
                        "height": 585
                    }
                },
                coverTitle: {
                    "position": {
                        "top" : 547,
                        "width": 220,
                        "left": 5, 
                        "height": 33
                    }
                },
                coverTitle2: {
                    "position": {
                        "top" : 505, 
                        "width": 220, 
                        "left": 5, 
                        "height": 33 
                    }
                },
                image0: {
                    "position": {
                        "top" : -50,
                        "left": 250, 
                        "width": 150,
                        "height": 245
                    },
                },
                image1: {
                    "position": {
                        "top" : 140,
                        "left": 420, 
                        "width": 190,
                        "height": 190
                    }, 
                },
                image2: {
                    "position": {
                        "top" : 220,
                        "left": 250, 
                        "width": 150,
                        "height": 190
                    },
                },
                image3: {
                    "position": {
                        "top" : 350,
                        "left": 420, 
                        "width": 190,
                        "height": 190
                    },  
                },
                image4: {
                    "position": {
                        "top" : 435,
                        "left": 250, 
                        "width": 150,
                        "height": 150
                    },
                },
                image5: {
                    "position": {
                        "top" : 560,
                        "left": 420, 
                        "width": 120,
                        "height": 270
                    },
                },
                imageStyle: {
                    "border": "5px solid var(--force-contast-color)",
                    "backgroundColor": "#508750",
                    "boxShadow": "0 13px 22px 0 #00000066, 0 2px 5px #000000EE"
                }, 
                "imageBorder": {
                    "borderWidth": 5,
                    "borderStyle": "dashed",
                    "borderColor": "var(--force-contast-color)"
                }
            },
            height: 870,
        },
        {
            floats:{
                text: {
                    "position": {
                        "top" : -20,
                        "left": 0,
                        "width": 550,
                        "height": 200,
                        "opacity": 1,
                        "rotate": 0
                    }
                },
                order:{
                "position": {
                        "top" : 195,
                        "left": 0,
                        "width": 150,
                        "height": 150
                    } 
                },
                cover: {
                    "position": {
                        "top" : 195,
                        "left": 340,  
                        "width": 210,
                        "height": 605,
                        "opacity": 1,
                        "rotate": 0
                    },
                },
                coverTitle: {
                    "position": {
                        "top": 567,
                        "left": 5,
                        "width": 200,
                        "height": 33,
                        "opacity": 1,
                        "rotate": 0
                    }
                },
                coverTitle2: {
                    "position": {
                        "top": 530,
                        "left": 5,
                        "width": 200,
                        "height": 33,
                        "opacity": 1,
                        "rotate": 0
                    } 
                },
                image0: {
                    "position": {
                        "top" : 195,
                        "left": 170,
                        "width": 150,
                        "height": 150
                    } 
                },
                image1: {
                    "position": {
                        "top" : 365,
                        "left": 0,
                        "width": 320,
                        "height": 150
                    } 
                },
                image2: {
                    "position": {
                        "top" : 535,
                        "left": -35,
                        "width": 100,
                        "height": 150
                    } 
                },
                image3: {
                    "position": {
                        "top" : 535,
                        "left": 80,
                        "width": 200,
                        "height": 150
                    }
                },
                image4: {
                    "position": {
                        "top" : 535,
                        "left": 295,
                        "width": 100,
                        "height": 150
                    } 
                },
                image5: {
                    "position": {
                        "top" : 705,
                        "left": 200,
                        "width": 120,
                        "height": 150
                    } 
                },
                imageStyle: {
                    "border": "5px solid var(--force-contast-color)",
                    "backgroundColor": "#508750",
                    "boxShadow": "0 13px 22px 0 #00000066, 0 2px 5px #000000EE"
                }, 
                "imageBorder": {
                    "borderWidth": 5,
                    "borderStyle": "dashed",
                    "borderColor": "var(--force-contast-color)"
                }
            },
            height: 870,
        },
        {
            floats:{
                text: {
                    "position": {
                        "top" : 605,
                        "left": 180, 
                        "width": 365,
                        "height": 230,
                        "opacity": 0,
                        "rotate": 0
                    },
                },
                order:{
                    "position": {
                        "top" : 85,
                        "left": 430, 
                        "width": 120,
                        "height": 120
                    }
                },
                cover: {
                    "position": {
                        "top" : 0,
                        "left": 180, 
                        "width": 230,
                        "height": 585
                    }
                },
                coverTitle: {
                    "position": {
                        "top" : 547,
                        "width": 220,
                        "left": 5, 
                        "height": 33
                    }
                },
                coverTitle2: {
                    "position": {
                        "top" : 505, 
                        "width": 220, 
                        "left": 5, 
                        "height": 33 
                    }
                },
                image0: {
                    "position": {
                        "top" : 0,
                        "left": 0, 
                        "width": 160,
                        "height": 160
                    }, 
                },
                image1: {
                    "position": {
                        "top" : 180,
                        "left": 0, 
                        "width": 160,
                        "height": 160
                    },
                },
                image2: {
                    "position": {
                        "top" : 360,
                        "left": 0, 
                        "width": 160,
                        "height": 160
                    },
                },
                image3: {
                    "position": {
                        "top" : 540,
                        "left": 0, 
                        "width": 160,
                        "height": 295
                    }, 
                },
                image4: {
                    "position": {
                        "top" : 225,
                        "left": 380, 
                        "width": 220,
                        "height": 220
                    }, 
                },
                image5: {
                    "position": {
                        "top" : 465,
                        "left": 430, 
                        "width": 120,
                        "height": 120
                    }, 
                },
                imageStyle: { 
                    "backgroundColor": "#508750",
                    "boxShadow": "0 13px 22px 0 #00000066, 0 2px 5px #000000EE"
                }, 
                "imageBorder": {
                    "borderWidth": 5,
                    "borderStyle": "dashed",
                    "borderColor": "var(--force-contast-color)"
                }
            },
            height: 870,
        },
    ]
}